// @ts-ignore
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import axios from "axios";
import { toast } from "react-toastify";
import {
  ACCESS_KEY,
  BUCKET_NAME,
  BUCKET_REGION,
  SECRET_ACCESS_KEY,
} from "../Config/secrets";
//dynamic image
const images = require.context(`/public/assets/images`, true);

export const dynamicImage = (image: string | undefined) => {
  return images(`./${image}`);
};

// POSTs a table's list payload to its export endpoint and saves the .xlsx. Errors
// arrive as a Blob (responseType "blob"), so the server's message is read out of it.
export const downloadExport = async (url: string, payload: any, headers: any, fileName: string) => {
  try {
    const response = await axios.post(url, payload, { headers, responseType: "blob" });
    const href = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(href);
    return true;
  } catch (error: any) {
    let message;
    try {
      message = JSON.parse(await error?.response?.data?.text())?.message;
    } catch {}
    toast.error(message || "Export failed", { autoClose: 6000 });
    return false;
  }
};

//dynamic Number
export function dynamicNumber(totalLength: number) {
  return Array.from({ length: totalLength }, (_, index) => index + 1);
}

export const normalizeUrl = (url: string) => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};

export const uploadFileToBucket = async (url: any, file: any) => {
  try {
    // console.log("File", file, `${url}/${file.name?.replace(/\s+/g, "")}`);
    const bucket = BUCKET_NAME;
    const key = `${url}/${file.name?.replace(/\s+/g, "")}`; // remove all spaces
    const s3 = new S3Client({
      region: BUCKET_REGION,
      endpoint: `https://${BUCKET_REGION}.digitaloceanspaces.com`,
      credentials: {
        accessKeyId: ACCESS_KEY || "",
        secretAccessKey: SECRET_ACCESS_KEY || "",
      },
    });

    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onload = async () => {
        try {
          const arrayBuffer = fileReader.result;
          const params: any = {
            Bucket: bucket,
            Key: key,
            Body: arrayBuffer,
            ACL: "public-read",
            ContentType: file.type, // Set the content type based on the file
          };
          // Implement ProgressListener
          const progressListener = () => {
            // const progressPercent = Math.ceil((progress.loaded / progress.total) * 100);
            // console.log(`Upload progress: ${progressPercent}%`);
            // Update your UI with the progress (e.g., progress bar)
            // You can pass a callback function to update UI from here
          };

          const command = new PutObjectCommand(params);
          await s3.send(command);
          // const command = new PutObjectCommand(params);
          // await s3.send(command);

          const s3ObjectUrl = `https://${bucket}.${BUCKET_REGION}.digitaloceanspaces.com/${key}`;
          // console.log("response from bucket after uploading ", s3ObjectUrl);

          resolve(s3ObjectUrl);
        } catch (uploadError) {
          console.error("Error uploading file:", uploadError);
          reject(uploadError);
        }
      };

      fileReader.onerror = (error) => {
        console.error("Error reading file:", error);
        reject(error);
      };

      fileReader.readAsArrayBuffer(file);
    });
  } catch (error) {
    console.log("Error uploading file:", error);
    throw error;
  }
};

export const uploadBase64ToBucket = async (url: any, base64String: any) => {
  try {
    console.log(
      "Base64 Upload",
      base64String.length,
      `${url}${Math.random() * 100}`
    );
    const bucket = BUCKET_NAME;
    const key = `${url}${Math.random() * 100}`; // remove all spaces
    const s3 = new S3Client({
      region: "ams3",
      endpoint: `https://ams3.digitaloceanspaces.com`,
      credentials: {
        accessKeyId: ACCESS_KEY || "",
        secretAccessKey: SECRET_ACCESS_KEY || "",
      },
    });

    // Convert Base64 to Buffer
    const base64Data = base64String.split(";base64,").pop();
    const buffer = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));

    const params: any = {
      Bucket: bucket,
      Key: key,
      Body: buffer,
      ACL: "public-read",
      ContentType: "image/png", // Ensure correct content type
    };

    // const progressListener = (progress: any) => {
    //   const progressPercent = Math.ceil(
    //     (progress.loaded / progress.total) * 100
    //   );
    //   console.log(`Upload progress: ${progressPercent}%`);
    // };

    const command = new PutObjectCommand(params);
    await s3.send(command);

    const s3ObjectUrl = `https://${bucket}.ams3.digitaloceanspaces.com/${key}`;
    console.log("response from bucket after uploading ", s3ObjectUrl);

    return s3ObjectUrl;
  } catch (error) {
    console.error("Error uploading base64:", error);
    throw error;
  }
};


export const permissionsList = [
  { id: 'dashboard', label: 'Dashboard', icon: 'Chart' },
  { id: 'companies', label: 'Companies', icon: 'Pie' },
  { id: 'brands', label: 'Brands', icon: 'Bag' },
  { id: 'retailers', label: 'Retailers', icon: 'Chart' },
  { id: 'verifications', label: 'Verifications', icon: 'Edit' },
  { id: 'queues', label: 'Queues', icon: 'Tick-square' },
  { id: 'management', label: 'Management', icon: 'Setting' },
  { id: 'invite', label: 'Invite', icon: 'Profile' },
  { id: 'plan_requests', label: 'Plan Requests', icon: 'Shield' },
  { id: 'pitti_invite', label: 'Pitti Invite', icon: 'Profile' },
  { id: 'invite_user', label: 'Invite User', icon: 'Filter' },
  { id: 'admin_users', label: 'Admin Users', icon: 'Shield' },
  { id: 'ai_knowledge_base', label: 'Train Vionne', icon: 'Book' },
  { id: 'brand_requests', label: 'Brand Requests', icon: 'Book' },
  { id: 'brand_request_approval', label: 'Brand Request Approval', icon: 'Book' },
];